import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=475bb2de&"
import script from "./DeviceInfo.vue?vue&type=script&lang=ts&"
export * from "./DeviceInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports